// import './services/wdyr.js'
import React from 'react'
import ReactDOM from 'react-dom'
import { Security } from '@okta/okta-react'
import { oktaAuth } from './services/authConfig'
import './index.css'
import App from './App'
import * as serviceWorker from './serviceWorker'
import './scss/atomic.scss'

const restoreOriginalUri = (_oktaAuth, originalUri) => {
  window.location.replace(originalUri || '/')
}

ReactDOM.render(
  <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
    <App />
  </Security>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
